export const HOME_URL = '/org/[slug]/panel/inicio/';
